import React from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ResponsivePage } from "../../../components/desktopUi";
import { MenuCard, MenuGrid } from "../../../components/managementUi";
import { appImages } from "../../../assets/appicons";
import { EMP_BASE_PATH } from "../../../config";

// Khớp app: app/(feature)/management/income/index.tsx
const IncomeManagerIndex = () => {
  const navigate = useNavigate();
  const base = `${EMP_BASE_PATH}/quan-ly/thu-nhap`;
  return (
    <ResponsivePage title="Quản lý thu nhập">
      <MenuGrid>
        <MenuCard
          icon={appImages.icon_khach_hang}
          label="Thống kê nhân viên"
          onClick={() => navigate(`${base}/nhan-vien`)}
        />
        <MenuCard icon={appImages.icon_Du_an} label="Thống kê vùng" onClick={() => navigate(`${base}/vung`)} />
        <MenuCard icon={appImages.icon_QLNV} label="Thống kê khối" onClick={() => navigate(`${base}/khoi`)} />
        <MenuCard
          icon={appImages.icon_thu_nhap}
          label="Thu nhập chờ chi trả"
          onClick={() => navigate(`${base}/cho-chi-tra`)}
        />
      </MenuGrid>
    </ResponsivePage>
  );
};

export default IncomeManagerIndex;
